import React, { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import {
    addNewChequeDetails,
    getAllClients,
    getChequeType,
    getProvider,
    manuallyChequeDetail,
    SubmitManuallChequeDetails
} from '../../Redux/Actions/DashOptions';
import { constructOptions } from '../../Utils/helper';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../Common/Loader';

const ManuallChequeCorrection = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [initialFormData, setInitialFormData] = useState([]);
    const [fieldsLoading, setFieldsLoading] = useState(false)

    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data || []);

    const manuallyDataList = useSelector((state) => state?.DashOptionsSlice?.getDataForManually?.data);
    const loading = useSelector((state) => state?.DashOptionsSlice?.isLoading)

    const chequeData = useSelector((state) => state?.DashOptionsSlice?.getChequeList?.data?.data) // cheque list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading


    const getChequeListingType = useSelector((state) => state?.DashOptionsSlice?.getChequeTypeData?.data) // get data for listing

    const clientData = useSelector((state) => state?.DashOptionsSlice?.allClients?.data) // client list data 



    const fields = [
        'cheque_Number',
        'member_no',
        'cheque_type',
        'client',
        'provider',
        'mrn',
        'patient',
        'claim_number',
        'expl_code',
        'month',
        'amount',
        'declined_amount',
        'approved_amount',
    ];

    const onSubmit = async (values) => {
        const updates = [];
        const creates = [];

        for (const entry of values.formData) {
            const baseEntry = {
                member_no: entry.member_no,
                mrn: entry.mrn,
                patient: entry.patient,
                claim_number: entry.claim_number,
                cheque_number: entry.cheque_Number,
                amount: parseFloat(entry.amount),
                approved_amount: parseFloat(entry.approved_amount),
                declined_amount: parseFloat(entry.declined_amount),
                client_id: Number(entry.client),
                provider_id: Number(entry.provider),
                cheque_type_id: Number(entry.cheque_type),
                expl_code: entry.expl_code,
            };

            if (entry.isNew) {
                creates.push({
                    ...baseEntry,
                    cheque_id: id,
                    month: entry.month?.split('-')?.[1] || '',
                    year: entry.month?.split('-')?.[0] || '',
                });
            } else if (entry.id) {
                updates.push({ ...baseEntry, id: entry.id, status: entry.status });
            }
        }

        let isSuccess = true;

        if (updates.length) {
            const res = await dispatch(SubmitManuallChequeDetails({ updates }));
            if (res?.type !== 'cheque-detail-manually/fulfilled') {
                isSuccess = false;
                toast.error('Update failed');
            }
        }

        if (creates.length) {
            const res = await dispatch(addNewChequeDetails({ entries: creates }));
            if (res?.type !== 'cheque-new-detail/fulfilled') {
                isSuccess = false;
                toast.error('Adding new entries failed');
            }
        }

        if (isSuccess) {
            toast.success('All entries submitted successfully');
            navigate('/dashboard/chequelist');
        }
    };


    const renderField = (fieldName, label, index) => {
        setFieldsLoading(true)
        const isSelect = [, 'cheque_type', 'client', 'provider'].includes(fieldName);
        const isMonth = fieldName === 'month';

        const getOptionsForField = () => {
            switch (fieldName) {

                case 'cheque_type':
                    return constructOptions(getChequeListingType, 'id', 'name');
                case 'cheque_Number':
                    return constructOptions(chequeData, 'cheque_number', 'cheque_number');
                case 'client':
                    return constructOptions(clientData, 'id', 'name');
                case 'provider':
                    return constructOptions(getProviderData, 'id', 'name');
                default:
                    return [];
            }
        };

        return (
            <div key={`${fieldName}-${index}`} className="w-full md:w-1/4 px-2 mb-4">
                {setFieldsLoading(false)}
                <label className="block text-sm font-semibold text-gray-700 mb-1">{label}</label>
                <Field name={`formData[${index}].${fieldName}`}>
                    {({ input }) => {
                        if (isSelect) {
                            const options = getOptionsForField();
                            const selected = options?.find(opt => opt.value === input.value) || null;
                            return (
                                <Select
                                    {...input}
                                    value={selected}
                                    options={options}
                                    isLoading={clientListLoading}
                                    onChange={(selected) => input.onChange(selected?.value || '')}
                                    className="text-sm"
                                />
                            );
                        } else if (isMonth) {
                            return (
                                <input
                                    {...input}
                                    type="month"
                                    className="border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 shadow-sm px-3 py-2 w-full rounded-md text-sm bg-white"
                                />
                            );
                        } else {
                            return (
                                <input
                                    {...input}
                                    type="text"
                                    className="border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 shadow-sm px-3 py-2 w-full rounded-md text-sm bg-white"
                                />
                            );
                        }
                    }}
                </Field>
            </div>
        );
    };

    const handleAddAnotherEntry = (e) => {
        e.preventDefault()
        const lastEntry = initialFormData[initialFormData.length - 1];
        const newEntry = {
            cheque_Number: lastEntry?.cheque_Number || '',
            member_no: '',
            cheque_type: lastEntry?.cheque_type,
            client: lastEntry?.client,
            provider: lastEntry?.provider,
            mrn: '',
            patient: '',
            claim_number: '',
            expl_code: lastEntry?.expl_code,
            month: '',
            amount: '',
            declined_amount: '',
            approved_amount: '',
            id: '',
            isNew: true
        };

        setInitialFormData((prev) => [...prev, newEntry]);
    };

    const handleRemoveEntry = (indexToRemove) => {
        setInitialFormData((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    useEffect(() => {
        setFieldsLoading(true)
        if (Array.isArray(manuallyDataList) && manuallyDataList.length > 0) {
            const transformed = manuallyDataList.map((item) => ({
                cheque_Number: item.cheque_number || '',
                member_no: item.member_no || '',
                cheque_type: item.cheque_type?.id || '',
                client: item.client?.id || '',
                provider: item.provider?.id || '',
                mrn: item.mrn || '',
                patient: item.patient || '',
                claim_number: item.claim_number || '',
                expl_code: item?.expl_code || '',
                month: item.year && item.month ? `${item.year}-${String(item.month).padStart(2, '0')}` : '',
                amount: item.amount || '',
                declined_amount: item?.declined_amount || '',
                approved_amount: item?.approved_amount || '',
                id: item?.id || ''
            }));
            setInitialFormData(transformed);
            setFieldsLoading(false)
        }
    }, [manuallyDataList]);

    useEffect(() => {
        setFieldsLoading(true)
        if (id) {
            dispatch(getProvider());
            dispatch(manuallyChequeDetail(id)).then((res) => { if (res) { setFieldsLoading(false) } });
            dispatch(getChequeType());
            dispatch(getAllClients());
        }
    }, [id]);

    return (
        <>
            <div className="max-w-[1400px] mx-auto p-6 bg-gradient-to-tr from-gray-50 via-white to-gray-100 rounded-lg shadow-xl">
                {(loading || fieldsLoading) && <Loader />}
                <div className="flex justify-between">
                    <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 mb-8 drop-shadow">
                        🧾 Manual Cheque Entry Form
                    </h2>
                    <div>
                        <button
                            onClick={() => navigate('/dashboard/chequelist')}
                            className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-lg transition"
                        >
                            Back
                        </button>
                    </div>

                </div>

                <Form
                    onSubmit={onSubmit}
                    initialValues={{ formData: initialFormData }}
                    render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            {initialFormData.map((_, index) => (
                                <div key={index} className="bg-white border border-gray-300 p-6 rounded-lg shadow-md mb-6">
                                    <div className="flex justify-between items-center mb-4">
                                        <h3 className="text-lg font-bold text-indigo-600 mb-4">Entry #{index + 1}</h3>
                                        {_.isNew && (
                                            <button
                                                type="button"
                                                className="text-red-600 hover:text-red-800 font-semibold text-sm"
                                                onClick={() => handleRemoveEntry(index)}
                                            >
                                                ❌ Cancel
                                            </button>
                                        )}
                                    </div>
                                    <div className="flex flex-wrap -mx-2">
                                        {fields.map((field) =>
                                            renderField(field, field.replace(/_/g, ' ').toUpperCase(), index)
                                        )}
                                    </div>
                                </div>
                            ))}

                            <div className="flex justify-end gap-3 mt-8">
                                <button
                                    type="button"
                                    className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold px-6 py-2 rounded-lg shadow-md transition"
                                    onClick={handleAddAnotherEntry}
                                >
                                    ➕ Add Another Entry
                                </button>
                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white font-semibold px-8 py-2 rounded-lg shadow-md transition"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    )}
                />
            </div>
        </>
    );
};

export default ManuallChequeCorrection;
